import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
// import FormularioGrid from './FormularioGrid.js'
import FormularioRecurrenciaGrid from './FormularioRecurrenciaGrid'
import FormularioRecurrenciaAbm from './FormularioRecurrenciaAbm.js'
import {FormattedMessage, injectIntl} from 'react-intl';

class FormularioRecurrencia extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="formulario.label_controles_recurrencia" defaultMessage="Controles de Recurrencia"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={FormularioRecurrenciaGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <FormularioRecurrenciaAbm {...props} intl={this.props.intl} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <FormularioRecurrenciaAbm {...props} intl={this.props.intl} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <FormularioRecurrenciaAbm {...props} action="VIEW" />} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default injectIntl(FormularioRecurrencia);
